export const bfiShareTypes = ['Standard', 'High Volume'];
